import { UcoastEl } from '@/scripts/core/UcoastEl'
import { getAttributeOrThrow, qsaOptional, qsaRequired, qsRequired } from '@/scripts/core/global'
import { type CartDrawer } from '@/scripts/cart/cart-drawer'
import { uCoastWindow } from '@/scripts/setup'

declare let window: uCoastWindow

export class RecipeCta extends UcoastEl {
	static htmlSelector = 'recipe-cta'
	ingredientSelectors: NodeListOf<HTMLInputElement>
	supplySelectors?: NodeListOf<HTMLInputElement>
	isCompleteBundle: boolean
	selectedIds: number[]
	recipeHandle: string
	recipeId?: string // for v2 function
	displayPriceEl: HTMLElement
	submitButton: HTMLButtonElement
	b2b: boolean

	constructor() {
		super()
		this.b2b = this.hasAttribute('data-uc-b2b')
		this.recipeHandle = getAttributeOrThrow('data-uc-recipe-handle', this)
		this.recipeId = this.getAttribute('data-uc-recipe-id') ?? undefined
		this.ingredientSelectors = qsaRequired(
			'input[type=checkbox][data-uc-recipe-ingredient-selector]'
		)
		this.supplySelectors = qsaOptional('input[type=checkbox][data-uc-recipe-supply-selector]')
		this.selectedIds = this.getSelectedIds()
		this.displayPriceEl = qsRequired('[data-uc-recipe-display-price]', this)
		this.submitButton = qsRequired('button', this)
		this.isCompleteBundle = this.selectedIds.length >= this.ingredientSelectors.length

		this.ingredientSelectors.forEach((input) => {
			if (!input.hasAttribute('data-uc-unavailable')) {
				input.addEventListener('change', this.updateSelection.bind(this))
			} else {
				input.addEventListener('change', (e) => e.preventDefault())
			}
		})
		this.supplySelectors?.forEach((input) => {
			if (!input.hasAttribute('data-uc-unavailable')) {
				input.addEventListener('change', this.updateSelection.bind(this))
			} else {
				input.addEventListener('change', (e) => e.preventDefault())
			}
		})
		this.submitButton.addEventListener('click', this.onSubmitHandler.bind(this))
	}

	updateSelection(_: Event) {
		// 1s timeout to avoid infinity
		console.log('updateSelection')
		window.setTimeout(() => {
			this.selectedIds = this.getSelectedIds()
			this.isCompleteBundle =
				this.getRequiredSelectedCount() === this.ingredientSelectors.length
			this.updateDisplayPrice()
		}, 1)
	}

	getRequiredSelectedCount() {
		return Array.from(this.ingredientSelectors).filter((selector) => {
			return selector.checked
		}).length
	}

	getSelectedIds() {
		if (this.supplySelectors) {
			return Array.from(this.ingredientSelectors)
				.concat(Array.from(this.supplySelectors))
				.filter((selector) => {
					return selector.checked
				})
				.map((selector) => {
					const id = getAttributeOrThrow('value', selector)
					return parseInt(id)
				})
		} else {
			return Array.from(this.ingredientSelectors)
				.filter((selector) => {
					return selector.checked
				})
				.map((selector) => {
					const id = getAttributeOrThrow('value', selector)
					return parseInt(id)
				})
		}
	}

	formatShopifyPrice(price: number, comparePrice?: number): string {
		if (comparePrice && comparePrice > price) {
			const comparePriceString =
				comparePrice % 100 === 0
					? `$${(comparePrice / 100).toFixed(0)}`
					: `$${(comparePrice / 100).toFixed(2)}`
			const priceString =
				price % 100 === 0 ? `$${(price / 100).toFixed(0)}` : `$${(price / 100).toFixed(2)}`
			return `<s>${comparePriceString}</s> ${priceString}`
		} else {
			return price % 100 === 0
				? `$${(price / 100).toFixed(0)}`
				: `$${(price / 100).toFixed(2)}`
		}
	}

	updateDisplayPrice() {
		let price = 0
		this.ingredientSelectors.forEach((selector) => {
			if (selector.checked) {
				const selectorPrice = parseInt(getAttributeOrThrow('data-price', selector))
				price += selectorPrice
			}
		})
		console.log('price before supplies', price)
		this.supplySelectors?.forEach((selector) => {
			if (selector.checked) {
				const selectorPrice = parseInt(getAttributeOrThrow('data-price', selector))
				price += selectorPrice
			}
		})
		console.log('price after supplies', price)
		if (price === 0) {
			this.submitButton.setAttribute('disabled', '')
		} else {
			this.submitButton.removeAttribute('disabled')
		}
		if (this.isCompleteBundle) {
			const bundlePrice = (price * 0.9).toFixed(0)
			this.displayPriceEl.innerHTML = this.formatShopifyPrice(parseInt(bundlePrice), price)
		} else {
			this.displayPriceEl.innerHTML = this.formatShopifyPrice(price)
		}
	}

	async onSubmitHandler(evt: Event) {
		evt.preventDefault()
		console.log('this.b2b', this.b2b)
		const cartDrawer = qsRequired<CartDrawer>('cart-drawer')

		const items = this.isCompleteBundle && !this.b2b
			? this.selectedIds.map((id) => {
					return {
						id: id,
						quantity: 1,
						properties: this.recipeId ? {
							_recipe_id: this.recipeId,
							_recipe_handle: this.recipeHandle,
						} : {
							_recipe_handle: this.recipeHandle,
						},
					}
			  })
			: this.selectedIds.map((id) => {
					return {
						id: id,
						quantity: 1,
					}
			  })

		const sectionIdsToRender = cartDrawer
			.getSectionsToRender()
			.filter((section) => section.id)
			.map((section) => section.id)

		const formData = {
			items: items,
			sections: sectionIdsToRender.join(','),
			sections_url: window.location.pathname,
		}

		cartDrawer.setActiveElement(document.activeElement)
		const config = {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Accept: `application/javascript`,
				'X-Requested-With': 'XMLHttpRequest',
			},
			body: JSON.stringify(formData),
		}

		void (await fetch(window.routes.cart_add_url, config)
			.then((response) => response.json())
			.then((response) => {
				if (response.status) {
					return
				}

				window.setTimeout(() => {
					cartDrawer.renderContents(response)
				}, 5)
			})
			.catch((e) => {
				console.error(e)
			})
			.finally(() => {
				cartDrawer.classList.remove('is-empty')
			}))
	}
}
